import * as React from "react";
const SvgHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M9.625 15v-2.7M6.943 1.365l-4.851 3.78c-.81.63-1.467 1.971-1.467 2.988v6.67c0 2.087 1.701 3.797 3.789 3.797h10.422a3.8 3.8 0 0 0 3.789-3.789V8.26c0-1.089-.729-2.484-1.62-3.105l-5.562-3.897c-1.26-.882-3.285-.837-4.5.108"
    />
  </svg>
);
export default SvgHome;
